import { render, staticRenderFns } from "./DatasetEdit.vue?vue&type=template&id=51696851&"
import script from "./DatasetEdit.vue?vue&type=script&lang=js&"
export * from "./DatasetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports